import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { api } from '@/lib/api';
import styles from './admin.module.scss';

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
  beforeLoad: async ({ context }) => {
    // CRITICAL: Require authentication and admin permissions
    const { user, authLoading } = context as { user: any; authLoading: boolean };

    // Don't redirect while auth is still loading
    if (authLoading) {
      return;
    }

    if (!user) {
      console.warn('Unauthorized access attempt to admin page');
      throw redirect({
        to: '/',
      });
    }

    // Check admin status through API (uses Firebase auth via Lambda authorizer)
    try {
      const { profile } = await api.getUserProfile();
      const isAdmin = profile?.permission_level?.admin === true;

      if (!isAdmin) {
        console.warn('Non-admin user attempted to access admin page:', user.uid);
        throw redirect({
          to: '/',
        });
      }
    } catch (error) {
      console.error('Failed to check admin status:', error);
      throw redirect({
        to: '/',
      });
    }
  },
});

function AdminLayout() {
  return (
    <div className={styles.admin}>
      <Outlet />
    </div>
  );
}
